module.exports = __webpack_public_path__ + "img/Group 9.fa6b9680.svg";